import classNames from 'classnames';
import React from 'react';
import styles from './ModalFooter.module.scss';

interface Props {
  /** @todo Inherited by ModalContent, clean up when consolidating */
  withForm?: boolean;
  children: React.ReactNode;
  secondaryActions?: React.ReactNode;
}
const ModalFooter = (props: Props) => (
  <footer className={classNames(styles.modalFooter, { [styles.withForm]: props.withForm })}>
    <div className={styles.primaryActions}>{props.children}</div>
    {!!props.secondaryActions && (
      <div className={styles.secondaryActions}>{props.secondaryActions}</div>
    )}
  </footer>
);
export default ModalFooter;
